import React from "react";
import { useLocation } from "react-router-dom";

const DocumentViewer = () => {
  const location = useLocation();
  const source = location.pathname.split("/").filter(Boolean).slice(-2, -1)[0]; // getting source
  const type = location.pathname.split("/").pop(); // get 'video' or 'doc'

  let sourceUrl = "";
  if (type === "video") {
    sourceUrl =
      source === "azure"
        ? "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/saml_assets/Azure_SAML_setup.mp4?autoplay=1"
        : "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/saml_assets/Okta_SAML_setup.mp4?autoplay=1";
  } else if (type === "doc") {
    sourceUrl =
      source === "azure"
        ? "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/saml_assets/azure-saml-setup-steps.pdf"
        : "https://tbr-ggk.s3.us-east-2.amazonaws.com/production/saml_assets/okta-saml-setup-steps.pdf";
  }

  return (
    <div style={{ height: "100vh", width: "100vw", margin: 0, padding: 0 }}>
      {sourceUrl ? (
        <iframe
          src={sourceUrl}
          frameBorder="0"
          allow="autoplay; fullscreen"
          allowFullScreen
          title="Viewer"
          style={{ height: "100%", width: "100%", border: "none" }}
        />
      ) : (
        <div style={{ color: "red", textAlign: "center", paddingTop: "50px" }}>
          Invalid type or source not found.
        </div>
      )}
    </div>
  );
};

export default DocumentViewer;
